<template>
  <button
  class="button pa-tag-menu-button"
  :disabled="isDisabled"
  :class="additionalClass"
  @click.prevent="handleClick"
  >{{item.label}}</button>
</template>

<script>
export default {
  props : {
    item : {
      default : null
    }
  },

  data(){
    return {
      slug            : null,
      label           : null,
      styleType       : 'mini',
      isLoading       : false,
      isDisabled      : false,

      additionalClass : {
        'mini'        : false,
        'long'        : false,
        'is-loading'  : false,
        'is-disabled' : false,
      }
    };
  },

  watch : {
    item  : {
      handler(data){
        this.slug       = data.slug;
        this.label      = data.label;
        this.styleType  = data.styleType;
        this.isLoading  = data.isLoading;
        this.isDisabled = data.isDisabled;
      },
      immediate: true,
      deep: true
    },

    styleType : {
      handler(value){
        switch(value){
          case 'mini':
            this.additionalClass['mini'] = true;
            this.additionalClass['long'] = false;
          break;
          
          case 'long':
            this.additionalClass['mini'] = false;
            this.additionalClass['long'] = true;
          break;
        }
      },
      immediate: true
    },

    isLoading : {
      handler(value){
        this.additionalClass['is-loading'] = value;
      },
      immediate: true
    }
  },

  methods : {
    handleClick(){
      this.$emit('onClick', this.item);
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

button.button.pa-tag-menu-button{
  display: block;
  box-sizing: border-box;
  width:49%;
  height:100%;
  margin-top:.6rem;
  user-select: none;
  background-color:#E8DCBB;
  border-radius:20px;
  margin:.3rem 0;
  padding:.2rem 0;
  text-align:center;
  font-size: .82rem;
  line-height: 1rem;
  height: inherit;
  border:0;

  transition: background-color 200ms, color 200ms;

  @include until(375px) {
    font-size: .72rem;
  }

  &.long{
    width:100%;
  }

  &.mini{
    font-size:.77rem;

    @include until(375px) {
      font-size:.68rem;
    }
  }

  &.is-loading::after{
    border: 1px solid #363636;
    border-right-color: transparent;
    border-top-color: transparent;
  }
}

.pa-message-set{
  &-default{
    button.button.pa-tag-menu-button{
      background-color:#E8DCBB;
    }
  }

  &-lilica{
    button.button.pa-tag-menu-button{
      background-color:#dfd4b5;
    }
  }
}
</style>